import { ReactElement } from 'react';
import { PermissionDTO } from '../PermissionDTO';
import { PermissionTooltip } from '../PermissionTooltip';
import { usePermissionAccess } from '../data/usePermissionAccess';

export function PermissionAction<T extends keyof PermissionDTO>({
  children,
  name,
  permission,
}: {
  children: ReactElement;
  name: T;
  permission: keyof NonNullable<PermissionDTO[T]>;
}) {
  const hasNoAccess = usePermissionAccess({ name, permission });

  if (hasNoAccess) {
    return <PermissionTooltip>{children}</PermissionTooltip>;
  }

  return children;
}
